var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_145_83)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9 16.0776C19.5333 16.0776 18.2111 15.8553 16.9778 15.4553C16.5889 15.322 16.1556 15.422 15.8556 15.722L14.1111 17.9109C10.9667 16.4109 8.02222 13.5776 6.45556 10.322L8.62222 8.47757C8.92222 8.16646 9.01111 7.73313 8.88889 7.34424C8.47778 6.1109 8.26667 4.78868 8.26667 3.42201C8.26667 2.82201 7.76667 2.32201 7.16667 2.32201H3.32222C2.72222 2.32201 2 2.58868 2 3.42201C2 13.7442 10.5889 22.322 20.9 22.322C21.6889 22.322 22 21.622 22 21.0109V17.1776C22 16.5776 21.5 16.0776 20.9 16.0776Z",
    fill: "#F5835E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_145_83"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24.322,
    fill: "white",
    transform: "translate(0 0.161007)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCall);
export default __webpack_public_path__ + "static/media/Call.cb7bc88cd733a5ae42f9d352a3b5b78f.svg";
export { ForwardRef as ReactComponent };